import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="not-found-page">
      <div className="not-found-page__container">
        <div className="not-found-page__illustration">
          <div className="not-found-page__illustration-404">404</div>
        </div>

        <div className="not-found-page__content">
          <h1 className="not-found-page__content-title">Trang không tồn tại</h1>

          <p className="not-found-page__content-description">
            Xin lỗi, trang bạn đang tìm kiếm không tồn tại hoặc đã bị di chuyển.
          </p>
        </div>

        <div className="not-found-page__actions">
          <Link
            to="/"
            className="not-found-page__btn not-found-page__btn--primary"
          >
            Về trang chủ
          </Link>
          <Link
            to="/schools"
            className="not-found-page__btn not-found-page__btn--secondary"
          >
            Tìm trường học
          </Link>
        </div>

        <div className="not-found-page__suggestions">
          <h3 className="not-found-page__suggestions-title">
            Có thể bạn quan tâm:
          </h3>
          <div className="not-found-page__suggestions-grid">
            <Link to="/schools" className="not-found-page__suggestions-item">
              <div className="not-found-page__suggestions-name">
                Danh sách trường học
              </div>
            </Link>
            <Link to="/reviews" className="not-found-page__suggestions-item">
              <div className="not-found-page__suggestions-name">
                Đánh giá mới nhất
              </div>
            </Link>
            <Link
              to="/schools/create"
              className="not-found-page__suggestions-item"
            >
              <div className="not-found-page__suggestions-name">
                Thêm trường mới
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
